import React, { useState, useEffect } from 'react';

/* Props:
  isOn: 'true', <Boolean> Value of the checkbox
  defaultIsOn: 'true', <Boolean> Default value of the checkbox, used if isOn is not defined
  handleToggle: Callback for the toggle event
  name: 'toggle-01', Name and id for the checkbox. ! MUST BE UNIQUE IF USING MULTIPLE TOGGLES ! 
  disabled: 'false', Boolean value to set checbox as disabled
  yesElem:
  noElem:
*/

export const TextOptionElem = ({text = I18n.t('option_yes'), side = 'left', className = '', ...rest}) => (
  <span className={className + ' react-switch-text-option-elem ' + side} {...rest}>{text}</span>
)

const ToggleSwitch = (
  {
    isOn, 
    defaultIsOn, 
    handleToggle = () => {}, 
    name, 
    disabled, 
    yesElem, 
    noElem, 
    labelElem,
    includeFalse,
    style={},
    wrapperProps = {},
    size='',
    checkedValue = 1,
    uncheckedValue = 0,
    className=''
  }
) => {
  const [checked, setChecked] = useState(isOn || defaultIsOn || false);

  useEffect(() => {
    if (typeof isOn != 'undefined') {
      setChecked(isOn || false);
    }
  }, [isOn])

  const onChange = (e) => {
    handleToggle(e);

    if (typeof isOn == 'undefined') {
      setChecked(!checked);
    }
  }

  return (
    <label htmlFor={'react-toggle-' + name} style={{marginBottom: 0}}>
    <div {...wrapperProps}>
      <input
        className={`react-switch-checkbox ${className}`}
        id={'react-toggle-' + name}
        type="checkbox"
        defaultValue={checkedValue}
        checked={checked}
        onChange={onChange}
        name={name}
        disabled={disabled}
      />
      {/* Send unchecked value along with the form */}
      {includeFalse && !checked && <input type="hidden" name={name} defaultValue={uncheckedValue} />}
      <div 
        className={`react-switch-label ${checked ? 'checked' : ''} ${size}`} 
        style={{ opacity: disabled ? 0.75 : 1 , ...style}}
      >
        <span className="react-switch-yes-elem">{checked && yesElem}</span>
        <span className="react-switch-button" />
        <span className="react-switch-no-elem">{!checked && noElem}</span>
      </div>
      {labelElem}
      </div>
    </label>
  );
};

export default ToggleSwitch;